import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

export const LikeButton = styled.button.attrs({ type: "button" })`
  display: inline-flex;
  justify-content: center;
`;

export const LikeIcon = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: ${px2rem(16)};
  height: ${px2rem(16)};
`;

export const LikeCount = styled.span`
  display: inline-block;
  margin-left: ${px2rem(2)};
  vertical-align: middle;
  font-size: ${px2rem(11)};
  line-height: ${px2rem(16)};
  color: ${props => props.theme.grey700};
`;
LikeCount.displayName = "LikeCount";
